export default {
  headingBetweenBlocks: {
    textAlign: 'center',
  },
};
